import clsx from 'clsx'
import './Heading.css'

interface HeadingProps {
    title: React.ReactNode
    size?: 'h2' | 'h3' | 'h4' | 'h5'
    actions?: React.ReactNode
    children?: React.ReactNode
    noSpacing?: boolean
}

export default function Heading({ title, actions, children, size = 'h2', noSpacing = false }: HeadingProps) {
    const HeadingTitle = `${size}` as keyof JSX.IntrinsicElements
    return (
        <div className={clsx('heading', `heading-${size}`, { 'no-spacing': noSpacing })}>
            <div className="heading-text">
                <HeadingTitle>{title}</HeadingTitle>
                {children && <div className="heading-desc">{children}</div>}
            </div>
            {actions && <div className="heading-actions">{actions}</div>}
        </div>
    )
}
